import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'medications',
    children: [
      {
        path: 'dispensing',
        loader: protectedLoader('MEDICATION', 'DISTRIBUTE_MEDICATION'),
        async lazy() {
          const {MedicationDistributionListPage} = await import(
            './pages/MedicationDistributionListPage'
          );
          return {
            element: <MedicationDistributionListPage />,
          };
        },
        children: [
          {
            path: 'summary',
            loader: protectedLoader('MEDICATION', 'DISTRIBUTE_MEDICATION'),
            async lazy() {
              const {MedicationDistributionSummaryPage} = await import(
                './pages/MedicationDistributionSummaryPage'
              );
              return {
                element: <MedicationDistributionSummaryPage />,
              };
            },
          },
          {
            path: ':id',
            loader: protectedLoader('MEDICATION', 'DISTRIBUTE_MEDICATION'),
            async lazy() {
              const {MedicationDistributionPage} = await import(
                './pages/MedicationDistributionPage'
              );
              return {
                element: <MedicationDistributionPage />,
              };
            },
          },
        ],
      },
    ],
  },
] as RouteObject[];

export const menuItems = [] as MenuItemElement[];
